import React from "react";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Paths } from "../../router/Paths";
import { setTourEdit } from "../../reducer/tourEditReducer";
import RoleBasedComponent from "../../components/RoleBasedComponent";

export default function ManageLocationsSection({ packageData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setTourEdit(packageData._id));
    navigate(Paths.tourManagementPackageLocation, {
      state: { packageData },
    });
  };

  const locations = packageData?.locations || [];

  // Split inclusions into two columns
  const mid = Math.ceil(locations.length / 2);
  const leftColumn = locations.slice(0, mid);
  const rightColumn = locations.slice(mid);

  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Locations</p>
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>
      {/* content  */}
      <div className="flex flex-col sm:items-end gap-6">
        {/* ✅ locations Mapped into Two Columns */}
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Country</p>
              <p className="text-secondary capitalize">
                {packageData?.country}
              </p>
            </div>
          </div>
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">City</p>
              <p className="text-secondary capitalize">{packageData?.city}</p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px]">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-1 sm:gap-4 text-sm text-gray-600">
            <div className="space-y-1">
              {leftColumn.map((item: string, index: number) => (
                <p key={index} className="flex gap-2 items-center">
                  <Icon className="text-[#7CDEAC]" icon="mdi:location" />
                  {item}
                </p>
              ))}
            </div>
            <div className="space-y-1">
              {rightColumn.map((item: string, index: number) => (
                <p key={index} className="flex gap-2 items-center">
                  <Icon className="text-[#7CDEAC]" icon="mdi:location" />
                  {item}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
